<div class="l-mybooking__menu" role="dialog" aria-label="Tab">
  <ng-container *ngFor="let tabComponent of tabComponentList">
    <button
      [ngClass]="[tabComponent.index === activeNum ? 'l-mybooking__menu-item is-current' : 'l-mybooking__menu-item']"
      type="button"
      id="_content{{ tabComponent.index }}"
      role="button"
      aria-label="dialogTitle"
      (click)="tabClick(tabComponent.index)"
      tabindex="0"
    >
      <span class="l-mybooking__menu-icon"
        ><img
          [src]="tabComponent.index !== activeNum ? tabComponent.src : tabComponent.srcActive"
          alt="Open"
          width="32"
          height="32"
      /></span>
      <span class="l-mybooking__menu-label">{{ tabComponent.title | staticMsg }}</span>
    </button>
  </ng-container>
</div>
<div
  *ngFor="let tabComponent of tabComponentList"
  class="l-tab-style02__contents"
  [ngClass]="{ 'is-active': tabComponent.index === activeNum }"
  role="tabpanel"
  aria-labelledby="i"
  tabIndex="{{ tabComponent.index }}"
>
  <ng-container [ngTemplateOutlet]="tabComponent.component"></ng-container>
</div>
